module.exports = __webpack_public_path__ + "static/media/Aakarsh.113a1f01.jpg";